const getNMinutesFromNowUTC = function(minutes) {
  const now = /* @__PURE__ */ new Date();
  return new Date(now.getTime() + minutes * 6e4);
};
const getNowUTC = () => {
  return (/* @__PURE__ */ new Date()).toISOString();
};
const validateEffectiveDateTimeFormat = function(effectiveDateTime) {
  const dateTimeRegexp = /\d{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2]\d|3[0-1])T(?:[0-1]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d+|)(?:Z|(?:\+|\-)(?:\d{2}):?(?:\d{2}))/;
  return dateTimeRegexp.test(effectiveDateTime);
};

export { getNMinutesFromNowUTC, getNowUTC, validateEffectiveDateTimeFormat };
//# sourceMappingURL=web-datetime.js.map
